import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { deleteData, getData } from "../../services/http.service";
import Constants from "../../services/constant";
// import profile from "../assets/demo/flags/profile.png";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import { Rating } from "primereact/rating";
import { formatDate } from "../../utils/dateConversions";
import dummy from "../../assets/images/dummy1.png"
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
const Weapons = () => {
    const toast = useRef(null);
    useEffect(() => {
        getAllWeapons();
    }, []);
    const getAllWeapons = () => {
        getData(Constants.END_POINT.WEAPONS)
            .then((res) => {
                if (res.success) {
                    setWeapons(res.data);
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const deleteWeapon = (id) => {
        deleteData(Constants.END_POINT.DELETE_WEAPON+id)
        .then((res)=>{
            if(res.success){
                toast.current.show({ severity: "info", summary: "", detail: "Weapon Deleted Succesfully", life: 3000 });
                getAllWeapons();
            }
        })
    }

    const [weapons, setWeapons] = useState();
    const [loading, setLoading] = useState(true);

    const weaponImageTemplate = (rowData) => {
        return <img src={rowData?.weaponImage ? Constants.BASE_URL+rowData?.weaponImage :dummy} style={{width:"70px",height:"70px"}}/>
    }

    const acceptFunc = (id) => {
        deleteWeapon(id)
        // toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    }

    const reject = () => {
        // toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }

    const deleteConfirm = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            rejectClassName:'cancel-button',
            accept:()=>acceptFunc(id),
            reject
        });
    };

    const ActionBodyTemplate = (rowData) => {
        return (
            <div className="flex">
                <Link to={`/weapon-edit/${rowData?._id}`}>
                    <Button type="button" className="p-button-info mx-2">
                        Edit
                    </Button>
                </Link>

                <Button
                    type="button"
                    className="p-button-danger "
                    onClick={()=>deleteConfirm(rowData?._id)}
                >
                    Delete
                </Button>   
            </div>
        );
    };

    return (
        <div className="col-12">
            <div className="card">
            <div className="flex justify-content-between mb-4">
            <Toast ref={toast} />
                        <h5>Weapons</h5>
                        <div className="flex justify-content-end mr-3">
                            <Link to="/create-weapon">
                                <Button className="p-button-info" icon="pi pi-plus" label="Create weapon" />
                            </Link>
                            {/* <Button label="Export" icon="pi pi-upload" className="p-button-help ml-3" onClick={() => ExportCSV(exportData)} /> */}
                        </div>
                    </div>
                <DataTable value={weapons} paginator rows={10} loading={loading}>
                    <Column field="weaponName"  header="Weapon Name" sortable  />
                    {/* <Column field="business.businessName" header="Business Name" sortable style={{ width: "30px" }} /> */}
                    <Column field="weaponImage" header="Weapon Image" sortable  body={weaponImageTemplate} />
                    <Column field="typeofWeapon"  header="Type Of Weapon" sortable  />
                    {/* <Column field="business.isVerified" header="Status" sortable body={statusBodyTemplate2} style={{ width: "30px" }} />
                    <Column field="time" header="Created On" sortable body={(d) => formatDate(new Date(d.time))} style={{ width: "30px" }} /> */}
                    <Column field="block" header="Action" body={ActionBodyTemplate} style={{width:'10px'}} />
                </DataTable>
            </div>
        </div>
    );
};

export default Weapons;
